<template>
	<div class="width-100 height-100 flex flex-col items-center justify-center text-primary-ops">
		<p class="heading">{{ $t('ops.landingPage.title') }}</p>
		<p class="text-md mt-2">{{ $t('ops.landingPage.message') }}</p>
	</div>
</template>
